<template>
  <div class="cookie-policy-wrapper">
    <b-link class="brand-logo" :to="{ name: 'foravila-home' }">
      <foravila-logo />
    </b-link>

    <div class="cookie-policy-inner">
      <h1 class="mb-1">{{ $t('legal.cookiePolicyTitle') }}</h1>
      <p class="last-updated text-muted mb-2">{{ $t('legal.cookiePolicyLastUpdated') }}</p>

      <p>{{ $t('legal.cookiePolicyIntro') }}</p>

      <h2 class="mt-3 mb-1">{{ $t('legal.cookiePolicyWhatIsCookieTitle') }}</h2>
      <p>{{ $t('legal.cookiePolicyWhatIsCookieText') }}</p>

      <h2 class="mt-3 mb-1">{{ $t('legal.cookiePolicyEssentialTitle') }}</h2>
      <p>{{ $t('legal.cookiePolicyEssentialText') }}</p>
      <ul>
        <li>{{ $t('legal.cookiePolicySessionCookie') }}</li>
        <li>{{ $t('legal.cookiePolicyConsentStorage') }}</li>
      </ul>

      <h2 class="mt-3 mb-1">{{ $t('legal.cookiePolicyNoAnalyticsTitle') }}</h2>
      <p>{{ $t('legal.cookiePolicyNoAnalyticsText') }}</p>

      <h2 class="mt-3 mb-1">{{ $t('legal.cookiePolicyNoThirdPartyTitle') }}</h2>
      <p>{{ $t('legal.cookiePolicyNoThirdPartyText') }}</p>

      <h2 class="mt-3 mb-1">{{ $t('legal.cookiePolicyRightsTitle') }}</h2>
      <p>{{ $t('legal.cookiePolicyRightsText') }}</p>

      <div class="mt-3">
        <b-button variant="primary" :to="{ name: 'foravila-home' }">
          {{ $t('pages.notFound.buttonText') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BLink, BButton } from 'bootstrap-vue'
import ForavilaLogo from '@/layouts/foravila/components/ForavilaLogo.vue'

export default {
  components: { BLink, BButton, ForavilaLogo },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-misc.scss';

.cookie-policy-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;

  .brand-logo {
    margin-bottom: 2rem;
  }
}

.cookie-policy-inner {
  width: 100%;

  h1 {
    font-size: 1.75rem;
    font-weight: 700;
  }

  h2 {
    font-size: 1.1rem;
    font-weight: 600;
  }

  .last-updated {
    font-size: 0.85rem;
  }

  ul {
    padding-left: 1.5rem;

    li {
      margin-bottom: 0.5rem;
    }
  }

  .contact-note {
    font-size: 0.9rem;
    color: #6e6b7b;
    border-top: 1px solid #ebe9f1;
    padding-top: 1rem;
  }
}
</style>
